import { post } from './API';
import downloadPdf from '../Utils/downloadPdf';

/**
 * Voucher PDF Service
 * Generates PDF vouchers for bookings via backend API
 */
const VoucherService = {
  /**
   * Generate a PDF voucher for a booking
   * @param {string} bookingId - The booking ID
   * @param {string} language - Language code (en, hu, ru, uk, de)
   * @param {Object} options - Additional options
   * @param {string[]} options.linkedBookingIds - IDs of linked bookings for combined pricing
   * @param {boolean} options.combinePrices - Whether to combine prices of linked bookings
   * @param {boolean} options.hidePrice - Whether to hide price on the voucher
   * @param {boolean} options.isPaid - Whether the booking has been paid
   * @returns {Promise<{pdf: string, filename: string}>} Base64 PDF and filename
   */
  generatePdf: async (bookingId, language, options = {}) => {
    const response = await post('/bookings/vouchers', {
      bookingId,
      language,
      linkedBookingIds: options.linkedBookingIds || [],
      combinePrices: options.combinePrices || false,
      hidePrice: options.hidePrice || false,
      isPaid: options.isPaid || false,
    });
    return response.data?.data;
  },

  /**
   * Generate and download a PDF voucher
   * @param {string} bookingId - The booking ID
   * @param {string} language - Language code
   * @param {Object} options - Additional options
   */
  downloadPdf: async (bookingId, language, options = {}) => {
    const result = await VoucherService.generatePdf(bookingId, language, options);

    downloadPdf(result, 'voucher.pdf');

    return result;
  },
};

export default VoucherService;
